'use client'
import {
  RICHTEXT_QUERY
} from "./chunk-G62SUGCR.mjs";
import {
  LINK_QUERY
} from "./chunk-Y5YNZ765.mjs";
import {
  IMAGE_QUERY
} from "./chunk-AFUSNP5S.mjs";

// src/api/queries/contentCard.ts
var CMS_CARD_QUERY = `
sys { id }
id
title
subtitle
description{${RICHTEXT_QUERY}}
featured
icon{${IMAGE_QUERY}}
link{${LINK_QUERY}}
`;
var getCmsCardQuery = ({ contentListLimit = 10 } = {}) => `
${CMS_CARD_QUERY}
contentListCollection(limit: ${contentListLimit}) {
  items {${CMS_CARD_QUERY}}
}
`;

export {
  CMS_CARD_QUERY,
  getCmsCardQuery
};
//# sourceMappingURL=chunk-AT6TTRZ3.mjs.map